import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  logo: {
    width: 20,
    height: 20,
  },
}));
